import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {QuestionFlow} from '../../models/underwriter.model';

export interface QuestionFlowState extends EntityState<QuestionFlow>{

}

@Injectable({providedIn: 'root'})
export class QuestionFlowStore extends SignalEntityStore<QuestionFlow, QuestionFlowState>{
    constructor(){
        super({name: 'question-flows', idKey: 'flow_id'});
    }
}
